<template>
  <fin-dynamic-etf-filter-display :filters="loadData"
                                  :hideFilter="hideFilter"
                                  :ignore-default-filters="ignoreDefaultFilters"
                                  @input="val => $emit('input', val)">
    <slot/>
  </fin-dynamic-etf-filter-display>
</template>

<script>
import {API, graphqlOperation} from "@/plugins/finAmplifyModules"
import {getEtfFiltersByClass} from "@/components/common/Strategy/DynamicEtfFilter/graphql"
import FinDynamicEtfFilterDisplay from "@/components/common/Strategy/DynamicEtfFilter/display"
import Cryptocurrencies from '@/mocks/Cryptocurrencies'

export default {
  name: "FinDynamicEtfFilter",
  components: {FinDynamicEtfFilterDisplay},
  props: {
    /** The id to retrieve the strategy filters from e.g. ETF_CORPORATE_BONDS_DYNAMIC */
    etfFilterClass: {
      type: String,
      required: true,
      validator(value) {
        // The value must match one of these strings, see EtfStrategyModel DynamoDB table
        return ['ETF_COMMODITIES_BASIC', 'ETF_COMMODITIES_CONSERVATIVE', 'ETF_COMMODITIES_DYNAMIC',
          'ETF_CORPORATE_BONDS_BASIC', 'ETF_CORPORATE_BONDS_CONSERVATIVE', 'ETF_CORPORATE_BONDS_DYNAMIC',
          'ETF_EQUITY_BASIC', 'ETF_EQUITY_CONSERVATIVE', 'ETF_EQUITY_DYNAMIC',
          'ETF_GOVERNMENT_BONDS_BASIC', 'ETF_GOVERNMENT_BONDS_CONSERVATIVE', 'ETF_GOVERNMENT_BONDS_DYNAMIC'].indexOf(value.toUpperCase()) !== -1
      }
    },
    /** If the default filters are ignored none is selected initially */
    ignoreDefaultFilters: {
      type: Boolean,
      default: false
    },
    /** Used to hide the display of the filter while still applying the filter */
    hideFilter: {
      type: Boolean,
      default: false
    },
    /** Used to hide the display of cryptocurrency-filters */
    hideCrypto: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    async loadData() {
      try {
        let result = await API.graphql(graphqlOperation(getEtfFiltersByClass, {
          filterClass: this.etfFilterClass.toUpperCase()
        }))
        if (this.hideCrypto && this.etfFilterClass.toUpperCase() === 'ETF_COMMODITIES_DYNAMIC') {
          let filterItems = result.data.getFilterDefinition.filter.items
          filterItems[1].filterValues.values = filterItems[1].filterValues.values.filter(item => {
            return !Cryptocurrencies.items.includes(item.id)
          })
        }
        return result.data.getFilterDefinition
      } catch (error) {
        console.log("error reading filter definitions for " + this.etfFilterClass, error)
      }
    },
  }
}
</script>

<style scoped>

</style>
